import { Controller } from "stimulus";
import { trackPagePulseBatch } from "../global/page_pulse";

const queue = [];
let flushTimer = null;

export default class extends Controller {
  static values = {
    url: String,
    subjectType: String,
    subjectId: Number,
  };

  connect() {
    this.tracked = false;

    if (!("IntersectionObserver" in window)) {
      this.track();
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) {
        this.track();
      }
    }, { threshold: [0.5] });

    this.observer.observe(this.element);
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  track() {
    if (this.tracked || !this.urlValue || !this.subjectTypeValue) {
      return;
    }

    this.tracked = true;
    if (this.observer) {
      this.observer.disconnect();
    }

    const event = {
      event: "impression",
      url: this.urlValue,
      subjectType: this.subjectTypeValue,
    };

    if (this.hasSubjectIdValue) {
      event.subjectId = this.subjectIdValue;
    }

    queue.push(event);
    scheduleFlush();
  }
}

function scheduleFlush() {
  if (flushTimer) {
    return;
  }

  flushTimer = window.setTimeout(() => {
    flushTimer = null;
    const events = queue.splice(0, queue.length);
    if (events.length > 0) {
      trackPagePulseBatch(events);
    }
  }, 250);
}
